﻿import {translation} from "@2d-front-monorepo/core";
import {
	AllPermitsResult,
	IntegraZone,
	PermitResult
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {formatDate, formatTime} from "../../../functions";

export function HolderComponent({permit, permits, zone}: {permit: PermitResult, permits: AllPermitsResult, zone?:IntegraZone }): JSX.Element {
	return <div className="card">
		<div className="columns gap padded">
			<dl className="permit__date col25">
				<dt>{translation(PermitTranslations.start_date)}</dt>
				<dd>
					<span>{formatDate(permit.startDate.toDateOnly())}</span>
					<span>{formatTime(permit.startDate.toTimeOnly())}</span>
				</dd>
			</dl>
			<dl className="permit__date col25">
				<dt>{translation(PermitTranslations.end_date)}</dt>
				<dd>
					<span>{permit.endDate && formatDate(permit.endDate.toDateOnly())}</span>
					<span>{permit.endDate && formatTime(permit.endDate.toTimeOnly())}</span>
				</dd>
			</dl>

			{zone && <dl className="title-desc col25">
                <dt>{translation(PermitTranslations.zone)}</dt>
                <dd>{zone.name || zone.id}</dd>
            </dl>}

			<dl className="title-desc col25">
				<dt>{translation(PermitTranslations.email)}</dt>
				<dd>{permits.holder.email}</dd>
			</dl>
		</div>
	</div>
}
